import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core';
import { ResponsivePie } from '@nivo/pie';
import { NoDataMessage } from '../../NoDataMessage';
import { CustomLegend } from './CustomLegend';

export const Pie = (props) => {
  const { data, showTotal, theme } = props;
  const classes = useStyles();
  const [hideItems, setHideItems] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const curtheme = useTheme();

  let innerRadius;
  let border;

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const keys = data.map((k) => k.id);
  const total =
    data.length > 0
      ? data.map((v) => v.value).reduce((prev, cur) => prev + cur, 0)
      : 0;

  if (showTotal) {
    innerRadius = 0.6;
    border = 1;
  }

  const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
    let sum = 0;
    dataWithArc.forEach((datum) => {
      sum += datum.value;
    });
    if (showTotal)
      return (
        <text
          x={centerX}
          y={centerY}
          textAnchor="middle"
          dominantBaseline="central"
          style={{
            fill: curtheme.palette.typeColor.graph,
            fontSize: 24,
            fontWeight: 600,
          }}
        >
          {sum}
        </text>
      );
    else return <></>;
  };

  const handleClick = (key) => {
    let curItems = hideItems;

    curItems.includes(key)
      ? curItems.splice(curItems.indexOf(key), 1)
      : curItems.push(key);

    setHideItems(curItems);
    setFilteredData(data.filter((d) => !hideItems.includes(d.id)));
  };

  return (
    <div className={classes.graphContainer}>
      {total > 0 ? (
        <>
          <div className={classes.legendContainer}>
            <CustomLegend keys={keys} colors={theme} onHide={handleClick} />
          </div>
          <ResponsivePie
            data={filteredData}
            margin={{ top: 10, right: 20, bottom: 10, left: 10 }}
            sortByValue={true}
            innerRadius={innerRadius}
            padAngle={border}
            cornerRadius={0}
            activeOuterRadiusOffset={8}
            colors={theme}
            enableArcLinkLabels={false}
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: 'color' }}
            arcLabelsSkipAngle={10}
            arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
            layers={[
              'arcs',
              'arcLabels',
              'arcLinkLabels',
              'legends',
              CenteredMetric,
            ]}
            animate={true}
            transitionMode="startAngle"
            tooltip={({ datum: { id, value, color } }) => {
              return (
                <div className={classes.toolContainer}>
                  <div style={{ display: 'flex' }}>
                    <strong style={{ color }}>{id}:&nbsp;</strong>{' '}
                    <span style={{ color: 'white' }}>
                      {((value / total) * 100).toFixed(2)}%
                    </span>
                  </div>
                </div>
              );
            }}
          />
        </>
      ) : (
        <NoDataMessage subTitle="Try Again Later" />
      )}
    </div>
  );
};

Pie.propTypes = {
  data: PropTypes.array.isRequired,
  showTotal: PropTypes.bool.isRequired,
  theme: PropTypes.array,
};

const useStyles = makeStyles((theme) => ({
  graphContainer: {
    width: '90%',
    height: '90%',
  },
  toolContainer: {
    fontSize: 12,
    padding: 12,
    color: 'white',
    background: '#222222',
  },
  legendContainer: {
    position: 'relative',
    top: -15,
    display: 'flex',
    width: '100%',
    justifyContent: 'left',
    paddingRight: 15,
    marginTop: -18,
  },
}));
